// removed by extract-text-webpack-plugin
module.exports = {"orderlistcomponent":"_2Lx2E7hfDdHdTaeycpkSfC","danlie":"_20cP5OGDvqvwHsmKnV06ME","danlieul":"_3zzDGoRdK221p72Ys7maiL","active":"_3LXIVM6BvHMQYKO4hc6p2f","danlieshou":"_2q-gNW19Nua4E_euCgWVTI","inp":"_2rL4qfCnBrS_pus9Ldow7G","linka":"_2AO-fAsglX4ufaDyPSxwjI","linkb":"_1e8Dn5_rZ5TEaUWoMIodws","jiesuannpage":"EETmQsnsklwa2-sx7OSLr","pagechildren":"_2TdRg7daj6AKNkk5sAZY35","childa":"_2rRWpjC_vecgLQjig_S9om","childb":"IsL7iRvuqiaHQK7WnWi-8","pagelienew":"_5c9NAfjL-A-OwviqK6Rc_","lienewtop":"_7rRtSmQMQ1Z59xBkqm8sj","newtoptxt":"IQSzao6WPkh_KBN20_oag","danliebtn":"c_nffE_USfDe_8TrLpQEQ"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/OrderList/OrderList.scss
 ** module id = 1080
 ** module chunks = 0
 **/